import { connect } from 'react-redux';

import { fetchGroups, fetchGroupCategories } from '../../actions/products_actions';

import CategoryAnalysis from '../../components/General/CategoryAnalysis';

const mapStateToProps = state => ({
  category: state.categoryAnalysis.category,
  categories: state.products.groups,
  subCategories: state.products.groupCategories,
});

export default connect(
  mapStateToProps,
  {
    fetchGroups,
    fetchGroupCategories,
  },
)(CategoryAnalysis);



// WEBPACK FOOTER //
// ./master/jsx/containers/General/CategoryAnalysis.jsx